import React from "react";
import { formatDate, formatDateTime } from "../../util/FormUtils";
import GroupAllUsers from "../FieldTags/GroupAllUsers";

const newPlan = window.location.pathname === "/xplans/new";

const CreatedInfo = ({ createdBy, createdAt, updatedBy, updatedAt, approvedBy, approvedDate }) => {
    return (
        <>
            {!newPlan &&
                <div className="planField">
                    <div className="notVisible">
                        <GroupAllUsers />
                    </div>
                    <div className="planOpenedChangedInfo fullLength">
                        <h2 className="planOpenedInfo">
                            Opened{" "}
                            <span className="planOpenedDate">
                                {formatDateTime(createdAt)}
                            </span>{" "}
                            by <span className="planOpenedBy">{createdBy}</span>
                        </h2>
                        {approvedBy &&
                            <h2 className="planChangedInfo">
                                Approved{" "}
                                <span className="planApprovedDate">
                                    {formatDate(approvedDate)}
                                </span>{" "}
                                by <span className="planApprovedBy">{approvedBy}</span>
                            </h2>
                        }
                        <h2 className="planChangedInfo">
                            Changed{" "}
                            <span className="planChangedDate">
                                {formatDateTime(updatedAt)}
                            </span>{" "}
                            by <span className="planChangedBy">{updatedBy}</span>
                        </h2>
                    </div>
                </div>
            }
        </>
    );
};

export default CreatedInfo;